import React from "react";
import { Routes, Route } from "react-router-dom";
import Hero from "./components/hero/Hero";
import Highlights from "./components/Highlights";
import About from "./components/About";
import Residences from "./components/Residences";
import Amenities from "./components/Amenities";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import PaymentPlan from "./components/PaymentPlan";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Developer from "./components/Developer";
import ConstructionUpdate from "./components/ConstructionUpdate";
import VideoSection from "./components/VideoSection";
import NearbyPlaces from "./components/NearbyPlaces";
import Commercial from "./components/Commercial";
import ProjectVideoSection from "./components/ProjectVideoSection";
import FloorPlanPdf from "./components/FloorPlanPdf";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminConstructionUpdate from "./admin/AdminConstructionUpdate";
import AdminVideos from "./admin/AdminVideos";
import AdminPaymentPlans from "./admin/AdminPaymentPlans";
import AdminDocuments from "./admin/AdminDocuments";
import AdminGallery from "./admin/AdminGallery";
import AdminSettings from "./admin/AdminSettings";
import ProtectedRoute from "./admin/ProtectedRoute";

const Landing = () => (
  <div className="app">
    <Hero />
    <Highlights />
    <About />
    <ProjectVideoSection />
    <Residences />
    <Commercial />
    <Amenities />
    <FloorPlanPdf />
    <Gallery />

    <Location />
    <NearbyPlaces />
    <VideoSection />
    <ConstructionUpdate />
    <PaymentPlan />
    <Faq />
    <Contact />
    <Developer />
    <Footer />
  </div>
);

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="construction" element={<AdminConstructionUpdate />} />
        <Route path="videos" element={<AdminVideos />} />
        <Route path="payment-plans" element={<AdminPaymentPlans />} />
        <Route path="documents" element={<AdminDocuments />} />
        <Route path="gallery" element={<AdminGallery />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
};

export default App;
